import request from "./../utils/request";

/**
 *
 * @param data: {fullname, email, subject, message, visitorId, languageCode}
 * @returns {Promise<AxiosResponse<any>>}
 */
export function createOfflineSupportRequest(data) {
    data = {
        ...data,
        customerClientHost: window.location.origin,
    };
    return request({
        url: `/offlineSupportRequests`,
        data,
        method: "put",
    });
}

export function rateOSR(data) {
    return request({
        url: `/public/offlineSupportRequests/${data.id}/rate`,
        headers: { "site-id": data.siteId },
        data,
        method: "post",
    });
}



// WEBPACK FOOTER //
// ./src/api/offlineSupportRequest.js